import { ClickEvent, DataSourceExecutionEvent } from "@mcleod/components";
import { Navigation, ObjectUtil } from "@mcleod/core";
import { AutogenLayoutStatusQuickInfo } from "./autogen/AutogenLayoutStatusQuickInfo";

export class StatusQuickInfo extends AutogenLayoutStatusQuickInfo {
    private _viewStatusURL = "lme/datafusion/ViewEdiStatus?mode=update&key=";

    openClassicStatus(event: ClickEvent) {
        const statusId = this.sourceEdistatus.activeRow.get("id");
        Navigation.navigateTo(this._viewStatusURL + statusId, { newTab: true });
    }

    afterExecution() {
        if (this.sourceEdistatus.activeRow != null) {
            if (this.sourceEdistatus.activeRow.get("is_resend") !== "Y") {
                this.imageIsResend.visible = false;
            }
            if (this.sourceEdistatus.activeRow.get("delay_code") === null ||
                this.sourceEdistatus.activeRow.get("delay_code") === undefined) {
                this.labelDelayCode.text = "--";
            }
            if (this.sourceEdistatus.activeRow.get("event_type") === "AP"
                || this.sourceEdistatus.activeRow.get("event_type") === "LC") {
                this.labelAppointmentDate.visible = false;
                this.labelAppointment.visible = false;
                this.labelApptTZ.visible = false;
            }
        }
    }

    beforeExecute(event: DataSourceExecutionEvent) {
        if (ObjectUtil.isObject(event.filter) && Object.keys(event.filter).length == 0) {
            event.filter["empty_search"] = "*"; 
        }
    }
}
